import React, { useEffect, useState } from 'react';

import { Button } from '@bumble/ui-kit';
import { Widget } from '@typeform/embed-react';
import FocusTrap from 'focus-trap-react';
import { useRouter } from 'next/router';

import styles from './typeform-modal.module.scss';

export default function TypeformModal() {
  const [showModal, setShowModal] = useState(false);
  const router = useRouter();

  const handleClose = () => {
    setShowModal(false);
    // eslint-disable-next-line @typescript-eslint/no-unused-vars
    const { subscribe, ...query } = router.query;
    router.replace(
      {
        pathname: router.pathname,
        query,
      },
      undefined,
      { shallow: true },
    );
  };

  useEffect(() => {
    if (router.query.subscribe === 'updates') {
      document.body.style.overflow = 'hidden';
      setShowModal(true);
    } else {
      document.body.style.overflow = 'auto';
      setShowModal(false);
    }
  }, [router.query]);

  const typeformId = 'NXC5bH6X';

  if (!typeformId) {
    console.error('Typeform ID is not set');

    return null;
  }

  if (!showModal) {
    return null;
  }

  return (
    <FocusTrap
      focusTrapOptions={{
        escapeDeactivates: true,
        initialFocus: false,
        allowOutsideClick: false,
      }}
      active={showModal}
    >
      {/* eslint-disable-next-line jsx-a11y/no-static-element-interactions, jsx-a11y/click-events-have-key-events */}
      <div className={styles.modal} data-lenis-prevent={true} onClick={handleClose}>
        {/* eslint-disable-next-line jsx-a11y/no-autofocus */}
        <Widget id={typeformId} className={styles.typeform} autoFocus={true} />

        <div className={styles.close}>
          <Button onClick={handleClose} size="small" icon="generic-close" isCircle={true} />
        </div>
      </div>
    </FocusTrap>
  );
}
